import { SERVICES_RESP , store} from '../../configurations';
import { APP_THEME_SUPPORTS } from '../../constants/app';
import { PARAMS } from '../../constants/params';
import { USER_ACTION } from '../../constants/user';
import { ACTION_TYPE, WINVEST_PARAMS_REMOVE_TOKEN, WINVEST_PARAMS_REMOVE_UUID } from '../../constants/win-vest';
import { getDeviceInfo } from '../../helpers/global';
import { userServices } from '../../services/user-services';
import { switchStockSetting, switchTheme, toggleQuote } from '../app';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import {Converter} from '@/helpers/functions'
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'
import { I_TRADE_ACTION as types } from '@/constants/i-trade';
import { THEME_COLOR_KEYS } from '@/constants/preference';


export const userActions = {
  updateAccountInformationAction,
  getPreferencesAction,
  updatePreferencesAction,
  getAlertAction,
  updateAlertAction,
  getBankAccountAction,
  getWatchlistAction,
  manageWatchlistAction,
  getQuoteHistoryAction,
  manageQuoteHistoryAction,
  getInstrumentWatchlistAction,
  addNewWatchlistAction,
  deleteWatchlistAction,
  getReportTypeAction,
  getMarketPostAction,
  getMarketAttachPostAction,
  getHotTopInstrumentAction,
  getMarketCommentSendReportAction,
  getPostListAction,
  postSubscribeAction,
  postUnsubscribeAction,
  getMarketCommentReplyAction,
  getMarketCommentPostDetailAction,
  updateUserPreferencesAction,
  getVirtualTradingWatchlist,
  getVirtualTradingUserInfoAction,
  getVirtualTradingTradingAccountAction,
  getVirtualTradingRankingAction,
  getVirtualTradingCompetitionListAction,
  getVirtualTradingPortfoliosAction,
  getVirtualTradingManageWatchlistAction,
  getVirtualTradingOrderEnquiryAction,
  getVirtualTradingCreatWatchlistAction,
  updateBankAccountAction
}

function updateAccountInformationAction(params, callback) {
  const p = {
    ...params
  }
  return () => {
    userServices.updateAccountInformationService(p, res => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getPreferencesAction(params, callback) {
  return dispatch => {
    userServices.getPreferencesService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        callback(res);
        if(res.result?.client_theme) dispatch(switchTheme(res.result.client_theme === APP_THEME_SUPPORTS[0] ? APP_THEME_SUPPORTS[1] : APP_THEME_SUPPORTS[0]))
        if(res.result?.auto_quote) dispatch(toggleQuote(res.result.auto_quote === 'Y'))
        if(res.result?.rise_fall_color) dispatch(switchStockSetting(res.result.rise_fall_color))
        // }
      }
    })
  }
}

function updateUserPreferencesAction(params, callback) {
  return (dispatch, getState) => {
    let language = ""
    if(params[THEME_COLOR_KEYS.SYSTEM] || params[THEME_COLOR_KEYS.DOWN_INDICATOR] ){
      language = 'und'
    }else{
      language = Converter.mappingWinVestLanguage(getState().app.language.lang)
    }
    const uuid = getState().user.userInfo.id
    if (uuid) {
      const p = {
        [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
        [WINVEST_PARAMS_REMOVE_TOKEN.KEY]: WINVEST_PARAMS_REMOVE_TOKEN.VALUE,
        [WINVEST_PARAMS_REMOVE_UUID.KEY]: WINVEST_PARAMS_REMOVE_UUID.VALUE,
        uuid,
        language,
        ...Object.entries(params).reduce((prev, next) => {
          if (next[1] && typeof next[1] === 'object') {
            prev[next[0]] = JSON.stringify(next[1])
          } else {
            prev[next[0]] = next[1]
          }
          return prev
        }, {})
      }
      userServices.updateUserPreferencesService(p, res => {
        callback(res)
        const data = {[language]: Object.assign({}, getState().user.preference[language] || {}, res.result)}
        const preference = Object.assign({}, getState().user.preference, data)
        dispatch({ type: USER_ACTION.SET_PREFERENCE, preference })
      })
    }
  }
}

function updatePreferencesAction(params, callback) {
  const p = {
    ...params,
    [PARAMS.DEVICE]: getDeviceInfo().device,
    [PARAMS.DEVICE_ID]: appConfigConstants.winvestorDeviceID,
    [PARAMS.KEY]: 'ntf_app_promote',
    [PARAMS.VALUE]: 'Y'
  }
  return () => {
    userServices.updatePreferencesService(p, res => {
      callback(res)
    })
  }
}

function getAlertAction(params, callback) {
  return () => {
    userServices.getAlertService(params, res => {
      callback(res)
    })
  }
}

function updateAlertAction(params, callback) {
  return () => {
    userServices.updateAlertService(params, res => {
      callback(res)
    })
  }
}

function getBankAccountAction(params, callback) {
  return (dispatch) => {
    userServices.getBankAccountService(params, res => {
      callback(res)
      dispatch({
        type:types.SET_DEPOSIT_BANK_ACCOUNT,
        depositBankAccount:res.result.daccountList
      })
    })
  }
}

function getWatchlistAction(params, callback) {
  return (dispatch) => {
    userServices.getWatchlistService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res.result)
        dispatch({
          type: ACTION_TYPE.GET_WATCHLIST,
          watchlist: res.result
        })
      } else {
        let res = []
        callback(res)
      }
    })
  }
}

function manageWatchlistAction(params, callback) {
  return () => {
    return userServices.manageWatchlistService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getQuoteHistoryAction(params, callback) {
  return () => {
    return userServices.getQuoteHistoryService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res.result)
      } else {
        let res = []
        callback(res)
      }
    })
  }
}

function manageQuoteHistoryAction(params, callback) {
  return () => {
    return userServices.manageQuoteHistoryService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getInstrumentWatchlistAction(params, callback) {
  const lang = store.getState().app.language.lang;
  const p = {
    template: 'watchlist2',
    category: 'B',
    ...params,
    language: Converter.mappingWinVestLanguage(lang)
  }
  return (dispatch) => {
    return userServices.getInstrumentWatchlistService(p, res => {
      const preDefined = [], custom = []
      if (res.status === SERVICES_RESP.STATUS_OK) {
        res.result.forEach(wl => {
          if (wl.category === 'P') {
            preDefined.push(wl)
          } else if (wl.category === 'C') {
            custom.push(wl)
          }
        })
      }
      const watchlist = { preDefined, custom }
      dispatch({
        type: USER_ACTION.GET_WATCHLIST2,
        watchlist
      })
      callback(res)
    })
  }
}

function addNewWatchlistAction(params, callback) {
  return () => {
    return userServices.addNewWatchlistService(params, res => {
        callback(res)
    })
  }
}

function deleteWatchlistAction(params, callback) {
  return () => {
    return userServices.deleteWatchlistService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getHotTopInstrumentAction(params, callback) {
  return () => {
    return userServices.getHotTopInstrumentService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}
function getReportTypeAction(params, callback) {
  return () => {
    return userServices.getMarketReportTypeService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}


function getMarketPostAction(params, callback) {
  return () => {
    return userServices.getMarketPostService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getMarketAttachPostAction(params, nid, callback) {
  return () => {
    return userServices.getMarketAttachPostService(params, nid, res => {
        callback(res)
    })
  }
}

function getMarketCommentSendReportAction(params, callback) {
  return () => {
    return userServices.getMarketCommentSendReportService(params, res => {
        callback(res)
    })
  }
}


function getPostListAction(params, callback) {
  return (dispatch) => {
    userServices.getPostListService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res.result)
      } else {
        let res = []
        callback(res)
      }
    })
  }
}

function postSubscribeAction(params, callback) {
  return (dispatch) => {
    userServices.postSubscribe(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res.result)
      } else {
        let res = []
        callback(res)
      }
    })
  }
}

function postUnsubscribeAction(params, callback) {
  return (dispatch) => {
    userServices.postUnsubscribe(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res.result)
      } else {
        let res = []
        callback(res)
      }
    })
  }
}


function getMarketCommentReplyAction(params, callback) {
  return () => {
    return userServices.getMakrketCommentReplyService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}


function getMarketCommentPostDetailAction(params, callback) {
  return () => {
    return userServices.getMakrketCommentPostDetailService(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        callback(res)
      }
    })
  }
}

function getVirtualTradingWatchlist(params,callback){
  return () => {
    return userServices.grtVirtualWatchlistService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingUserInfoAction(params,callback){
  return () => {
    return userServices.grtVirtualUserInfoService(params,res => {
      callback(res)
    })
  }
}


function getVirtualTradingTradingAccountAction(params,callback){
  return () => {
    return userServices.grtVirtualTradingAccountService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingRankingAction(params,callback){
  return () => {
    return userServices.grtVirtualRankingService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingCompetitionListAction(params,callback){
  return () => {
    return userServices.grtVirtualCompetitionListService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingPortfoliosAction(params,callback){
  return () => {
    return userServices.grtVirtualPortfoliosService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingManageWatchlistAction(params,callback){
  return () => {
    return userServices.grtVirtualManageWatchlistService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingOrderEnquiryAction(params,callback){
  return () => {
    return userServices.grtVirtualOrderEnquiryService(params,res => {
      callback(res)
    })
  }
}

function getVirtualTradingCreatWatchlistAction(params,callback){
  return () => {
    return userServices.grtVirtualCreatWatchlist(params,res => {
      callback(res)
    })
  }
}

function updateBankAccountAction(params, callback) {
  return () => {
    return userServices.updateAccountBankService(params, (res) => {
      callback(res);
    });
  };
}